(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Event-Page-product-slider"]) return;
  try {
    
  if (!customElements.get('event-page-slider')) {
    class EventPageSlider extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.signal = this.abortController.signal;
        this.sliders = this.querySelectorAll('[data-slider-track]');

        if (!this.sliders.length) return;

        this.bindSliderGroups();
        this.bindQuickShop();
        this.bindAddForms();
      }

      disconnectedCallback() {
        if (this.abortController) {
          this.abortController.abort();
        }
      }

      bindSliderGroups() {
        this.sliders.forEach((slider) => {
          const sliderSection = slider.closest('.event-page-template__products');
          if (!sliderSection) return;

          this.bindArrows(sliderSection, slider);
          this.bindDragging(slider);
        });
      }

      bindArrows(sliderSection, slider) {
        const prev = sliderSection.querySelector('[data-slider-prev]');
        const next = sliderSection.querySelector('[data-slider-next]');
        const getAmount = () => {
          const firstCard = slider.querySelector('.event-page-template__card');
          return firstCard ? firstCard.getBoundingClientRect().width + 30 : 350;
        };

        if (prev) {
          prev.addEventListener('click', () => {
            slider.scrollBy({ left: -getAmount(), behavior: 'smooth' });
          }, { signal: this.signal });
        }

        if (next) {
          next.addEventListener('click', () => {
            slider.scrollBy({ left: getAmount(), behavior: 'smooth' });
          }, { signal: this.signal });
        }
      }

      bindDragging(slider) {
        let isPointerDown = false;
        let startX = 0;
        let startScrollLeft = 0;

        slider.style.cursor = 'grab';

        slider.addEventListener('pointerdown', (event) => {
          isPointerDown = true;
          startX = event.clientX;
          startScrollLeft = slider.scrollLeft;
          slider.style.cursor = 'grabbing';
          slider.style.scrollSnapType = 'none';
        }, { signal: this.signal });

        const stopDragging = () => {
          isPointerDown = false;
          slider.style.cursor = 'grab';
          slider.style.scrollSnapType = 'x mandatory';
        };

        slider.addEventListener('pointerleave', stopDragging, { signal: this.signal });
        slider.addEventListener('pointerup', stopDragging, { signal: this.signal });
        slider.addEventListener('pointercancel', stopDragging, { signal: this.signal });

        slider.addEventListener('pointermove', (event) => {
          if (!isPointerDown) return;
          event.preventDefault();
          const walk = (event.clientX - startX) * 2;
          slider.scrollLeft = startScrollLeft - walk;
        }, { signal: this.signal });
      }

      bindAddForms() {
        this.querySelectorAll('[data-event-page-add-form]').forEach((form) => {
          if (form.dataset.eventPageBound === 'true') return;
          form.dataset.eventPageBound = 'true';
          new theme.AjaxProduct(form);
        });
      }

      bindQuickShop() {
        if (!window.theme || !theme.settings.quickView) return;

        this.querySelectorAll('[data-quick-shop-trigger]').forEach((link) => {
          if (link.dataset.eventPageQuickBound === 'true') return;
          link.dataset.eventPageQuickBound = 'true';

          const handle = link.dataset.productHandle;
          const productId = link.dataset.productId;
          const productUrl = link.dataset.productUrl || link.href;
          const modalId = 'QuickShopModal-' + productId;
          const modalEl = document.getElementById(modalId);

          if (!handle || !productId || !modalEl) return;

          link.classList.add('js-modal-open-quick-modal-' + productId);

          const preload = () => {
            if (link.dataset.eventPageQuickLoaded === 'true') return;
            if (theme.config.bpSmall) return;
            link.dataset.eventPageQuickLoaded = 'true';
            theme.preloadProductModal(handle, productId, link);
          };

          link.addEventListener('mouseenter', preload, { signal: this.signal });
          link.addEventListener('focus', preload, { signal: this.signal });

          link.addEventListener('click', (event) => {
            if (theme.config.bpSmall) {
              event.preventDefault();
              window.location.href = productUrl;
              return;
            }

            preload();

            const holder = document.getElementById('QuickShopHolder-' + handle);
            if (!holder || !holder.children.length) {
              event.preventDefault();
              if (link.dataset.eventPageQuickRetry === 'true') {
                window.location.href = productUrl;
                return;
              }

              link.dataset.eventPageQuickRetry = 'true';
              setTimeout(() => {
                const refreshedHolder = document.getElementById('QuickShopHolder-' + handle);
                if (refreshedHolder && refreshedHolder.children.length) {
                  link.click();
                } else {
                  window.location.href = productUrl;
                }
              }, 250);
            } else {
              link.dataset.eventPageQuickRetry = 'false';
            }
          }, { signal: this.signal });
        });
      }
    }

    customElements.define('event-page-slider', EventPageSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
